import NewFeedDailogShare from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogShare";
import NewFeedPostComponent from "components/app/new-feed-post/NewFeedPostComponent";
import NewFeedRightSidebar from "components/app/new-feed-post/NewFeedRightSidebar";
import ShimmerLoader from "components/app/new-feed-post/ShimmerLoader";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { PostReaction } from "models/postReaction";
import { useEffect, useState } from "react";
import { AppLog } from "services";
import appStore from "store/appStore";
import useProfileStore from "store/useProfile";
import { RouteUrl, StatusMsg } from "utils";
import DialogPostReaction from "components/app/dialog/DialogPostReaction";
import PostOption from "components/app/post-option/PostOption";
import NewFeedDialogReportPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogReportPost";
import NewFeedDailogDeletePost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogDeletePost";
import NewFeedDialogBoostPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBoostPost";
import NewFeedDailogBlock from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBlock";
import DialogNewFeedPost from "components/app/dialog/dialog-new-feed-post/DialogNewFeedPost";

interface ProfileFeedContentProps {
  user: any;
  feeds: any[];
}

export default function ProfileFeedContent({ user, feeds }: ProfileFeedContentProps) {
  const { onOpenDialogPostModal, onCloseDialogPostModal, showDialogUploadEditPostContent } = appStore();
  const { onClickedLike, onClickedFollow, onClickedShare, feedPostsRecord, onPostFeedUpdate } = useProfileStore();

  const [dialogPostReaction, setDialogPostReaction] = useState({
    isOpen: false,
    post: null,
    postReaction: PostReaction.like,
  });

  const [dialogShare, setDialogShare] = useState({
    isOpen: false,
    post: null,
  });

  const [dialogBlock, setDialogBlock] = useState({
    isOpen: false,
    post: null,
    optionKey: "",
  });

  const onOpenDialogBlock = (post: any, optionKey: string) => {
    try {
      setDialogBlock({
        isOpen: true,
        post: post,
        optionKey: optionKey,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBlock]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogDeletePost, setDialogDeletePost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogDeletePost = (post: any) => {
    try {
      setDialogDeletePost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogDeletePost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogReportPost, setDialogReportPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogReportPost = (post: any) => {
    try {
      setDialogReportPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogReportPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogBoostPost, setDialogBoostPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogBoostPost = (post: any) => {
    try {
      setDialogBoostPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBoostPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogNewFeedPost, setDialogNewFeedPost] = useState<{
    isOpen: boolean;
    post: any | null;
    video: HTMLVideoElement | null;
    videoCurrentTime: number;
    videoIsPlaying: boolean;
  }>({
    isOpen: false,
    post: null,
    video: null,
    videoCurrentTime: 0,
    videoIsPlaying: false,
  });

  const [postOption, setPostOption] = useState<{
    isOpen: boolean;
    buttonRef: HTMLButtonElement | null;
    post: any;
  }>({
    isOpen: false,
    buttonRef: null,
    post: null,
  });

  const onOpenReactionDialog = (post: any, postReaction: PostReaction) => {
    try {
      setDialogPostReaction({
        isOpen: true,
        post: post,
        postReaction,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenReactionDialog]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenDialogShare = (post: any) => {
    try {
      setDialogShare({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogShare]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenDialogNewFeedPost = (post: any, video: HTMLVideoElement | null) => {
    try {
      setDialogNewFeedPost({
        isOpen: true,
        post: post,
        video: video,
        videoCurrentTime: video?.currentTime ?? 0,
        videoIsPlaying: video ? !video.paused : false,
      });
      if (video) {
        video.pause();
      }
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogNewFeedPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenPostOption = (e: React.MouseEvent<HTMLButtonElement>, post: any) => {
    setPostOption({
      isOpen: true,
      buttonRef: e.currentTarget,
      post: post,
    });
  };

  const onClosePostOption = () => {
    setPostOption({
      isOpen: false,
      buttonRef: null,
      post: null,
    });
  };

  useEffect(() => {
    const handlePopState = () => {
      console.log("onCloseDialogPostModal");
      onCloseDialogPostModal();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full px-2 ">
      <div className="flex">
        <div className="hidden lg:block w-[300px] p-2 sticky right-0 top-[90px] left-0 max-h-[500px]">
          <div className=" h-full flex flex-col  text-wrap">
            {/* Scrollable Content */}
            <div className="p-4  bg-gray-200 rounded-md dark:bg-slate-900  text-wrap overflow-hidden">
              <p className="text-lg font-bold">Introduction</p>
              <p className="text-sm pb-4">{user?.description}</p>
            </div>
          </div>
        </div>

        <div className="w-full max-w-[700px] min-h-[1000px] p-2">
          {feeds?.map((post: any) => (
            <div key={post.provider_post_id} className="mb-4">
              <NewFeedPostComponent
                post={post}
                onOpenReactionDialog={onOpenReactionDialog}
                onOpenDialogShare={onOpenDialogShare}
                onOpenDialogNewFeedPost={onOpenDialogNewFeedPost}
                onOpenPostOption={onOpenPostOption}
                onClickedLike={onClickedLike}
                onClickedFollow={onClickedFollow}
                onOpenPostModal={(postId) => onOpenDialogPostModal(postId, `${RouteUrl.profile}?id=${user?.id}&feed`)}
                tmpRouteUrl={RouteUrl.profile}
              />
            </div>
          ))}
          {feedPostsRecord.isLoadingMore() && <ShimmerLoader />}
        </div>

        <div className="hidden lg:block g:w-1/4 w-[300px] p-2 sticky top-[90px] max-h-[100px] right-0">
          <ScrollArea>
            <NewFeedRightSidebar />
            <ScrollBar orientation="vertical" />
          </ScrollArea>
        </div>
      </div>

      {/* Dialog */}
      {dialogPostReaction.isOpen && (
        <DialogPostReaction
          post={dialogPostReaction.post}
          isDialogOpen={dialogPostReaction.isOpen}
          postReaction={dialogPostReaction.postReaction}
          setIsDialogOpen={(isOpen) => setDialogPostReaction({ ...dialogPostReaction, isOpen })}
        />
      )}

      {dialogShare.isOpen && (
        <NewFeedDailogShare
          post={dialogShare.post}
          onSuccess={(post) => onClickedShare(post)}
          isDialogOpen={dialogShare.isOpen}
          setIsDialogOpen={(isOpen) => setDialogShare({ ...dialogShare, isOpen })}
        />
      )}

      {postOption.isOpen && (
        <PostOption
          isOpen={postOption.isOpen}
          onOpenChange={(_) => onClosePostOption()}
          post={postOption.post}
          buttonRef={postOption.buttonRef}
          handleOptionClick={(post, optionKey) => {
            if (optionKey === "share") {
              onOpenDialogShare(post);
            } else if (optionKey === "block_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "boring_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "delete") {
              onOpenDialogDeletePost(post);
            } else if (optionKey === "report") {
              onOpenDialogReportPost(post);
            } else if (optionKey === "boost_post") {
              onOpenDialogBoostPost(post);
            } else if (optionKey === "edit_post") {
              if (post.media_type === "photo" || post.media_type === "album" || post.media_type === "video") {
                showDialogUploadEditPostContent(post, (updatePost) => onPostFeedUpdate(updatePost));
              }
            }
          }}
        />
      )}

      {dialogNewFeedPost.isOpen && (
        <DialogNewFeedPost
          postProp={dialogNewFeedPost.post}
          isDialogOpen={dialogNewFeedPost.isOpen}
          videoCurrentTime={dialogNewFeedPost.videoCurrentTime}
          videoIsPlaying={dialogNewFeedPost.videoIsPlaying}
          setIsDialogOpen={(isOpen, videoCurrentTime, videoIsPlaying) => {
            try {
              if (dialogNewFeedPost.video) {
                dialogNewFeedPost.video.currentTime = videoCurrentTime;
                if (videoIsPlaying) dialogNewFeedPost.video.play();
              }
              setDialogNewFeedPost({
                ...dialogNewFeedPost,
                isOpen,
                video: null,
                videoCurrentTime: 0,
                videoIsPlaying: false,
              });
            } catch (error) {
              AppLog.show({
                message: `[Playback failed]`,
                status: StatusMsg.error,
                error,
              });
            }
          }}
          onOpenPostModal={(postId) => onOpenDialogPostModal(postId, RouteUrl.newsFeed)}
        />
      )}

      {dialogBlock.isOpen && (
        <NewFeedDailogBlock
          post={dialogBlock?.post}
          optionKey={dialogBlock?.optionKey}
          isDialogOpen={dialogBlock.isOpen}
          setIsDialogOpen={(isOpen) => setDialogBlock({ ...dialogBlock, isOpen })}
        />
      )}
      {dialogBoostPost.isOpen && (
        <NewFeedDialogBoostPost
          post={dialogBoostPost?.post}
          isDialogOpen={dialogBoostPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogBoostPost({ ...dialogBoostPost, isOpen })}
        />
      )}

      {dialogDeletePost.isOpen && (
        <NewFeedDailogDeletePost
          post={dialogDeletePost?.post}
          isDialogOpen={dialogDeletePost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogDeletePost({ ...dialogDeletePost, isOpen })}
        />
      )}

      {dialogReportPost.isOpen && (
        <NewFeedDialogReportPost
          post={dialogReportPost?.post}
          isDialogOpen={dialogReportPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogReportPost({ ...dialogReportPost, isOpen })}
        />
      )}
    </div>
  );
}
